import {type ReactNode, memo} from "react";
import {Box, Separator, Splitter, Stack} from "@chakra-ui/react";

export type SidebarSection = {label: ReactNode; content: ReactNode};

type ResizableSidebarLayoutProps = {
  /** Sections to display in the sidebar, separated by dividers */
  sections: SidebarSection[];
  /** Content to render in the main area */
  children: ReactNode;
};

export const ResizableSidebarLayout = memo(({sections, children}: ResizableSidebarLayoutProps) => (
  <Splitter.Root
    flex={1}
    minH={0}
    defaultSize={[25, 75]}
    panels={[
      {id: "sidebar", minSize: 15, maxSize: 35},
      {id: "content", minSize: 50},
    ]}
  >
    <Splitter.Panel id="sidebar">
      <Stack gap={0} h="full" overflowY="auto" scrollbarWidth="thin" bg="gray.50" separator={<Separator />}>
        {sections.map((section, i) => (
          <Box key={i}>{section.content}</Box>
        ))}
      </Stack>
    </Splitter.Panel>

    <Splitter.ResizeTrigger id="sidebar:content" />

    <Splitter.Panel id="content">
      <Stack gap={0} flex={1} minW={0} h="full" overflowY="auto">
        {children}
      </Stack>
    </Splitter.Panel>
  </Splitter.Root>
));
